import { render } from "./CreateSupplierModal.vue?vue&type=template&id=3fe1e71c"
import script from "./CreateSupplierModal.vue?vue&type=script&lang=js"
export * from "./CreateSupplierModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__